module.exports = __webpack_public_path__ + "fonts/AdelleSansSAGE.a718d42a.ttf";